export const videoPlayerSettings = {
    components: [
        {
            type: 'tabs',
            key: 'tabs',
            components: [
                {
                    key: 'display',
                    components: [
                        {
                            weight: 0,
                            type: 'textfield',
                            input: true,
                            key: 'label',
                            defaultValue: 'Video',
                            label: 'Label',
                            placeholder: 'Field Label',
                            tooltip: 'The label for this field that will appear next to it.',
                            validate: {
                                required: true
                            }
                        },
                        {
                            type: 'select',
                            input: true,
                            key: 'labelPosition',
                            label: 'Label Position',
                            tooltip: 'Position for the label for this field.',
                            weight: 20,
                            defaultValue: 'top',
                            dataSrc: 'values',
                            data: {
                                values: [
                                    { label: 'Top', value: 'top' },
                                    { label: 'Left (Left-aligned)', value: 'left-left' },
                                    { label: 'Left (Right-aligned)', value: 'left-right' },
                                    { label: 'Right (Left-aligned)', value: 'right-left' },
                                    { label: 'Right (Right-aligned)', value: 'right-right' },
                                    { label: 'Bottom', value: 'bottom' }
                                ]
                            }
                        },
                        {
                            weight: 500,
                            type: 'textfield',
                            input: true,
                            key: 'customClass',
                            label: 'Custom CSS Class',
                            placeholder: 'Custom CSS Class',
                            tooltip: 'Custom CSS class to add to this component.'
                        },
                        {
                            weight: 1200,
                            type: 'checkbox',
                            label: 'Hide Label',
                            tooltip: 'Hide the label of this component.',
                            key: 'hideLabel',
                            input: true,
                            defaultValue: false
                        }
                    ],
                    label: 'Display',
                    weight: 0
                },
                {
                    key: 'data',
                    components: [
                        {
                            type: 'select',
                            input: true,
                            key: 'dataFrom',
                            label: 'Data From',
                            defaultValue: 'url',
                            dataSrc: 'values',
                            data: {
                                values: [
                                    { label: 'Exist Value', value: 'existValue' },
                                    { label: 'Url', value: 'url' }
                                ]
                            }
                        },
                        {
                            weight: 0,
                            type: 'textfield',
                            input: true,
                            key: 'url',
                            label: 'Video URL',
                            placeholder: 'URL',
                            conditional: {
                                json: { '===': [{ var: 'data.dataFrom' }, 'url'] }
                            }
                        },
                        {
                            weight: 0,
                            type: 'textfield',
                            input: true,
                            key: 'videoType',
                            label: 'Video Type',
                            defaultValue: 'video/mp4',
                            placeholder: 'video/mp4'
                        }
                    ],
                    label: 'Data',
                    weight: 10
                }
            ]
        }
    ]
};
